import React from "react";

import coming_soon_img from "../../assets/coming-soon.png";
import new_img from "../../assets/new-icon.png";
import { AuthorReaderItem } from "../../../models/authors";

type ReaderBlockProps = {
  reader: AuthorReaderItem;
  slectActiveReader?: any;
  activeReader: string | false;
  cat_id?: string;
  disabled: boolean;
};

const ReaderBlock: React.FC<ReaderBlockProps> = ({
  reader,
  slectActiveReader,
  activeReader,
  cat_id,
  disabled,
}) => {
  return (
    <div
      onClick={slectActiveReader}
      data-id={reader.id}
      data-cat_id={cat_id}
      className={`reader_block_item ${
        activeReader === reader.id ? "active" : ""
      } ${disabled ? "disabled" : ""}`}
    >
      {reader.coming_soon ? (
        <img src={coming_soon_img} className="coming_soon" alt="Coming soon" />
      ) : disabled ? (
        <img
          src={
            "https://flangoo-cdn.s3.us-east-2.amazonaws.com/padlock_white.png"
          }
          className="padlock"
          alt="Coming soon"
        />
      ) : reader.is_new ? (
        <img src={new_img} className="is_new" alt="Coming soon" />
      ) : null}
      <div className="bg-img">
        {reader.images ? <img src={reader.images?.cover} alt="" /> : null}
      </div>
    </div>
  );
};

export default ReaderBlock;
